import { render, staticRenderFns } from "./BotaoCancelarConfirmar.vue?vue&type=template&id=6cc5436b"
import script from "./BotaoCancelarConfirmar.vue?vue&type=script&lang=js"
export * from "./BotaoCancelarConfirmar.vue?vue&type=script&lang=js"
import style0 from "./BotaoCancelarConfirmar.vue?vue&type=style&index=0&id=6cc5436b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports